export const USER_GROUPS = {
  accountingARAP: { value: 'arapteam', name: 'Accounting AR AP team' },
  accountingLeads: { value: 'accounting-leads', name: 'Accounting Leads' },
  bookingLead: { value: 'booking_lead', name: 'CM Booking Leads' },
  allowAccessOldFacility: {
    value: 'allow_access_old_facility_page',
    name: 'Allow Access to Old Facility Page',
  },
  allowAccessOldSD: {
    value: 'allow_access_old_shipment_details',
    name: 'Allow Access to Old Shipment Details Page',
  },
  allowAccessIssuePageList: {
    value: 'allow_access_issue_page_list',
    name: 'Allow Access to Issue Page List',
  },
  compliance: { value: 'compliance', name: 'Compliance' },
  claims: { value: 'claims', name: 'Claims' },
  tech: {
    value: 'tech',
    name: 'Tech',
  },
  groupsAdmin: {
    value: 'groups_admin',
    name: 'Groups_Admin',
  },
  shipperOnboarding: {
    value: 'shipper_onboarding',
    name: 'Shipper Onboarding',
  },
  shipmentLogsEarlyAccess: {
    value: 'allow_early_access_to_shipment_logs',
    name: 'Allow Early Access to the New Shipment Logs',
  },
  editShipperSchedulingPreferences: {
    value: 'edit_shipper_scheduling_preferences',
    name: 'Edit shipper scheduling preferences',
  },
}
